import React from 'react';
import classNames from 'classnames';
import './ColorSwatch.less';
import { ReactComponent as BigX } from 'assets/empty-block.svg';

export type SwatchSize = 'normal' | 'medium' | 'small';

interface IColorSwatchProps {
  className?: string;
  color: string;
  size?: SwatchSize;
  onClick?: React.MouseEventHandler;
}

const getClassName = (className?: string, size?: SwatchSize) =>
  classNames('dp-color-swatch', className, {
    'dp-color-swatch--small': size === 'small',
    'dp-color-swatch--medium': size === 'medium',
  });
const getColorStyle = (color: string) => ({
  background: color,
});

/**
 * Color swatch / chip for various color picker
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ColorSwatch({ className, color, onClick, size }: IColorSwatchProps) {
  return (
    <div className={getClassName(className, size)} onClick={onClick}>
      <BigX />
      {/* TODO checkers for translucent colors, instead of the X */}
      <div className="dp-color-swatch__fill" style={getColorStyle(color)} />
    </div>
  );
}
